/** @jsx jsx */
import { jsx } from 'theme-ui';
import { Divider as styles } from './Divider.styles';

export default function Divider() {
  return <div sx={styles} />;
}
